import React, { FC, useState } from 'react';
import styled from 'styled-components';

import Input from '@ad-scripts/presentation/components/common/input';
import SearchIcon from '@ad-scripts/presentation/components/lib/icons/search_icon';
import XIcon from '@ad-scripts/presentation/components/lib/icons/x_icon';

type TypeProps = {
  searchTextState: [string, Function];
  onChange: Function;
  dataAid?: string;
  [propName: string]: any;
};

const SearchInput: FC<TypeProps> = ({
  searchTextState,
  onChange,
  dataAid,
  className,
  onFocus,
  onBlur,
  ...otherInputProps
}) => {
  const [searchText, setSearchText] = searchTextState;
  const [isSearchFocused, setSearchFocused] = useState(false);

  const handleInputFocus: React.FocusEventHandler<HTMLInputElement> = evt => {
    setSearchFocused(true);
    onFocus && onFocus(evt);
  };
  const handleInputBlur: React.FocusEventHandler<HTMLInputElement> = evt => {
    setSearchFocused(false);
    onBlur && onBlur(evt);
  };

  // eslint-disable-next-line
  const renderClearSearch = (): JSX.Element | null => {
    if (!searchText) return null;

    return (
      <ClearInputIcon data-aid="searchInput-clear" onClick={() => setSearchText('')}>
        <XIcon />
      </ClearInputIcon>
    );
  };

  return (
    <SearchInputWrapper className={className} focused={isSearchFocused}>
      <StyledSearchIcon />
      <StyledInput
        data-aid={dataAid || 'searchInput-input'}
        value={searchText}
        onChange={onChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        {...otherInputProps}
      />
      {renderClearSearch()}
    </SearchInputWrapper>
  );
};

SearchInput.defaultProps = {
  autoFocus: true,
  className: 'inputWrapper',
  placeholder: 'Search',
};

const ClearInputIcon = styled.div`
  color: ${p => p.theme.colors.gray400};
  cursor: pointer;
  height: 16px;
  margin-right: 8px;
  width: 16px;
  z-index: 1;
  svg {
    fill: ${p => p.theme.colors.gray600};
    height: 16px;
    width: 16px;
  }
`;

const SearchInputWrapper = styled.div`
  align-items: center;
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => (p.focused ? p.theme.colors.gray600 : p.theme.colors.gray300)};
  border-radius: 18px;
  display: flex;
  height: 32px;
  position: relative;
  transition: border-color 100ms ease-in;
  width: inherit;
  &.inputWrapper {
    width: 100%;
  }
`;

const StyledInput = styled(Input)`
  background-color: transparent;
  border: 0;
  font-size: ${p => p.theme.fontSize.base};
  padding-left: 34px;
  width: 100%;
  padding-top: 0;
  position: relative;
  height: inherit;
  &::placeholder {
    color: ${p => p.theme.colors.gray500};
  }
`;

const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  margin-left: 10px;
  margin-right: 12px;
  width: 16px;
  fill: #999999;
  pointer-events: none;
  cursor: pointer;
`;

export default SearchInput;
